<template>
  <!-- 底部 -->
  <div class="footerB">
      <p>
        徐州市委宣传部主办
        <a href="//beian.miit.gov.cn" target="_blank">苏ICP备05003658号-5</a>
      </p>
      <p>CopyRight ©2013-2017 徐州报业网络传播有限公司　版权所有 建议浏览分辨率1024×768 IE 6.0以上</p>
      <p>技术支持：徐州云创数字科技有限公司</p>
      <p>
        <a target="_blank" href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=32039302000142" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="http://hfy-img.xzyunchuang.com/9ee74911eac1f85aa72385df896f74bd" style="float:left;"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
          苏公网安备 32039302000142号</p>
        </a>
      </p>
    </div>
    
</template>
<script>

export default {
name: 'contactUs',
data() {
return {
   botInfo:{}
}
},
mounted(){
  
},
methods: {
  goRouter(d){
    window.open(d, "_blank");
    // window.location.href=d;
  }
  
}
}
</script>
<style scoped lang="scss">
.footerB{
  margin-top: 30px;
  text-align: center;
  line-height: 22px;
  font-size: 12px;
  color: #333;
  p{
   
    &:last-child{
      margin: 10px 0;
      font-size: 14px;
      color: #939393;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bot.vue